module.exports = __webpack_public_path__ + "img/1522290863.2c8cb332.jpg";